module.exports = __webpack_public_path__ + "img/ser7.9a67cc88.png";